module.exports = __webpack_public_path__ + "img/Autodesk_logo_circle.137db08d.svg";